import { Label, Position, SpinButton, Text } from '@fluentui/react';
import { textProp } from 'global/Application';
import { INumberValue } from 'model/FlexibleAttributeModel';
import React, { useState } from 'react';

export enum EFormat {
    float2,
    int
}

interface IProps {
    [key: string]: any;
    fieldValueOnChange?: (event: any, value: INumberValue) => void;
    defaultFieldValue?: INumberValue;
    format?: EFormat;
    zeroAndAbove?: boolean; // if true, will not allow negative numbers

}

// TODO rename this to number entry
const WholeNumber: React.FC<IProps> = (props) => {
    const { label, disabled } = props

    const defaultValue = props.defaultFieldValue
        ? props.format === EFormat.float2
            ? props.defaultFieldValue?.value?.toFixed(2)
            : props.defaultFieldValue?.value?.toString()
        : undefined;

    const [value, setValue] = useState(defaultValue);

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{defaultValue ? defaultValue : '---'}</Text>
        </div>;

    const fieldValueOnChange = (value: string, event: any, onIncrement?: Boolean, onDecrement?: Boolean) => {

        let numberStr = '';

        if (props.format === EFormat.float2) {
            let number = parseFloat(value);

            if (onIncrement)
                number = number + 0.1;

            if (onDecrement)
                number = number - 0.1;

            if (props.zeroAndAbove && number < 0)
                number = 0;

            numberStr = number.toFixed(2);
        } else if (props.format === EFormat.int) {

            let number = parseInt(value);

            if (onIncrement)
                number = number + 1;

            if (onDecrement)
                number = number - 1;

            if (props.zeroAndAbove && number < 0)
                number = 0;

            numberStr = number.toString();
        } else {
            throw new Error("WholeNumber: format not supported");
        }
        
        setValue(numberStr);

        const newValue: INumberValue = {
            type: 'number',
            value: props.format === EFormat.float2
                ? parseFloat(numberStr!)
                : parseInt(numberStr!)
        }
        
        props.fieldValueOnChange?.(event, newValue);

    }

    //TODO this may run into an issue of fractions showing as ok but not committing to backend
    // probably needs a local controlled state for a bind back
    return (
        <div>
            <SpinButton
                key={value}
                step={props.format === EFormat.float2 ? 0.1 : 1}
                onIncrement={(value, event) => {
                    fieldValueOnChange(value, event, true, false);
                }}
                onDecrement={(value, event) => {
                    fieldValueOnChange(value, event, false, true);
                }}
                // styles={{ spinButtonWrapper: { maxWidth: '100%' } }}
                label={label}
                labelPosition={Position.top}
                onBlur={(event) => {
                    const value = event.currentTarget.value
                    fieldValueOnChange(value, event);
                }}
                disabled={disabled}
                value={value}
            />
        </div>
    )
}

export default WholeNumber